/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_SearchInputs */



/**
* | output |
* | --- |
* | "Search by name" |
*
* @param {Manager_Question_SearchInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_search = /** @type {((inputs?: Manager_Question_SearchInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_SearchInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zoek op naam")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom")
	return /** @type {LocalizedString} */ ("Search by name")
});